import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Committee from '../Committee'

export default function LayoutCommittee() {
    return (
        <>
            <Header />
            <Committee />
            <Footer />
        </>
    )
}
